// test2275
(2275 && 0);
